<main>

    <section class="inner_header" style="background-image: url(assets/about_banner.png);">
        <app-header></app-header>
        <div class="container inner_banner_container">
            <h1> Blog Details </h1>
        </div>
    </section>

    <section class="blog_det_sec">
        <div class="container">
            <div class="row">
                <div class="breadcramp">
                    <div>
                        <a  routerLink="/home">Home</a>
                        <a  routerLink="/blog">Blogs</a>
                        <a class="active_brd">{{blogDetail.title}} </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="container event_select_box">
            <div class="row">
                <div class="select_inner">
                    <div class="select_box_left">


                        <div class="year_cnt_lft">
                            <span>Year</span>
                            <div class="select">
                                <select>
          <option value="1">Select Year</option>
          <option value="2">2020</option>
          <option value="3">2021</option>
        </select>
                            </div>
                        </div>

                        <div class="year_cnt_rte">
                            <span>Month</span>
                            <div class="select">
                                <select>
<option value="1">Select Month</option>
<option value="2">Jan</option>
<option value="3">Feb</option>
</select>
                            </div>
                        </div>


                    </div>


                    <div class="select_tag">
                        <span>Tags</span>
                        <ul>
                            <li>#RESIDENTAIL</li>
                            <li>#COMMERCIAL</li>
                            <li>#INSTITUTIONAL</li>
                        </ul>
                    </div>
                </div>

            </div>

        </div> -->
    </section>

    <section class="blog_det_inn_sec">
        <div class="container">
            <div class="row no-gutters nopadding">
                <div class="col-md-8 blog_txt_lft px-0">
                    <img src="{{blogDetail.image_url}}">
                    <h2>{{blogDetail.title}}</h2>
                    <p [innerHtml]="blogDetail.description" class="blog-content">
                    </p>
                </div>

                <div class="col-md-4 more_b_rte px-0" *ngIf="blogs && blogs.length > 0">
                    <div class="blog_rte_inn">
                        <h1>More Blogs</h1>
                        <div class="more_blog_box" *ngFor="let blog of blogs" (click)="changeData(blog.id)">
                          <div class="more_blog_box_img">
                            <img src="{{blog.image_url}}">
                          </div>


                            <h1>{{blog.title}}</h1>
                            <p >{{(blog.description | htmlToPlaintext) |slice:0:100}}...</p>
                        </div>
                    </div>


                </div>
            </div>
        </div>

    </section>

</main>

<app-footer></app-footer>
